module.exports = __webpack_public_path__ + "img/icon_category_01.80a147f6.svg";